// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lH3F","newExpiryDate":"styles_newExpiryDate__2xxHu","footer":"styles_footer__OxVwo"};